<template>
  <div>
    <div id="paymentContainer" />

    <q-input
      v-model="newCardHolder"
      :disabled="sample"
      placeholder="Card Holder Name"
      dense
      borderless
      class="q-px-sm-lg q-mx-sm-xs q-mt-sm"
    />
    <div class="flex justify-between q-mt-md q-gutter-sm">
      <a
        class="cursor-pointer opaque-30"
        @click="goToProvider"
      >
        <img
          src="services/stripe.png"
          style="height: 25px;"
        />
      </a>
      <div class="text-caption text-body1 text-grey-6 text-center">
        Powered by <a class="cursor-pointer text-blue-grey-4" @click="goToProvider">Stripe</a>
      </div>
    </div>

    <page-banner
      v-if="isDevelopment"
      dense
      icon="mdi-exclamation"
      class="q-mt-md"
    >
      <q-item-label class="text-bold">
        You are running on a Stripe sandbox environment.
      </q-item-label>
      <q-item-label>Use the following test credit card details:</q-item-label>
      <q-item-label><b>Card Number:</b> 4242 4242 4242 4242</q-item-label>
      <q-item-label><b>Expiry:</b> 01/25</q-item-label>
      <q-item-label><b>CVC:</b> 123</q-item-label>
    </page-banner>
  </div>
</template>

<script>
import { markRaw } from 'vue'

export default {
  props: {
    sample: {
      type: Boolean,
      default: false
    },
    setupIntent: {
      type: String,
      default: null
    }
  },
  emits: ['generated', 'capture'],
  data () {
    return {
      isDevelopment: !!process.env.SANDBOX,
      newCardHolder: '',
      paymentHandler: null
    }
  },
  methods: {
    async makePayment () {
      if (!this.paymentHandler) {
        this.$emit('generated', {
          error: { message: 'Failed to connect to Stripe' }
        })
        return
      }

      if (!this.newCardHolder || this.newCardHolder.length < 1) {
        this.$emit('generated', {
          error: { message: 'Enter a valid card holder name' }
        })
        return
      }

      this.$loading.show()
      if (this.setupIntent) {
        const { setupIntent, error } = await this.$stripe.confirmCardSetup(this.setupIntent, {
          payment_method: {
            card: this.paymentHandler,
            billing_details: {
              name: this.newCardHolder
            }
          }
        })
        this.$loading.hide()
        this.$emit('generated', {
          token: setupIntent ? setupIntent.payment_method : null,
          error
        })
      }
      else {
        const { token, error } = await this.$stripe.createToken(this.paymentHandler)
        this.$loading.hide()
        this.$emit('generated', {
          token: token ? token.id : null,
          error
        })
      }
    },
    mountProvider () {
      const elements = this.$stripe.elements()
      const style = {
        base: {
          color: '#32325d',
          '::placeholder': {
            color: '#8F8F8F'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      this.paymentHandler = markRaw(elements.create('card', { style, hidePostalCode: true, disabled: this.sample }))
      this.paymentHandler.mount('#paymentContainer')

      this.paymentHandler.on('focus', () => {
        this.$emit('capture')
      })
    },
    goToProvider () {
      this.goToHref('https://stripe.com', true)
    }
  },
  mounted () {
    if (this.$q.platform.is.nativeMobile) { return }
    this.mountProvider()
  }
}
</script>
